<template lang="pug">
div.relative
  .flex.max-w-1366.m-auto.z-300.relative
    //- .border.absolute.top-0.left-24.h-60.w-60.mr-48.cursor-pointer.z-300.flex-shrink-0.rounded-50.shadow-back.border.flex.items-center.justify-center.bg-white(@click="back")
    .absolute.top-0.left-24.w-60.mr-48.bg-red-200(@click="back")
      //- img.w-full( src='@/assets/asus-iuc-ico-back.png')
      .fixed.h-60.w-60.mr-48.cursor-pointer.z-350.flex-shrink-0.rounded-50.shadow-back.border.flex.items-center.justify-center.bg-white(@click="back")
        iCon.h-32.w-32.text-main-0(:iconClass="'ico_System back'" type="svg" )
    .py-16.px-32.pb-48.ml-120.bg-white.rounded-12.shadow-bg.z-300.mr-20.w-888(class="xl:w-1162")
      h1.text-left.text-24.text-main-0.mb-10.font-700 {{$t('__faqRelated.__faq')}}
      .bg-grey-aa.w-full.h-3
      .mx-64.m-auto
        faqModel.mt-20(:data="faqList" :height="48" customIcon="*" :fontSize="16")
          template(#content="{ data,index}")
            .bg-grey-cc.w-full.h-px.mt-14
            .text-left.py-40.px-16.editor_style
              div(v-html="$xss(data.answer)") 
              .bg-gray-300.w-200.h-3.mt-48.mb-24.m-auto
              div(v-if="!data.isFeedBack")
                .text-14.text-center {{$t('__faqRelated.__wasThisArticleHelpful')}}
                .m-auto.flex.justify-center.mt-16
                  Button.w-140.mr-16( :text="$t('__globeButton.__yes')"  type="normal" :disable="false" @buttonClick="vote(true,data.id,index)")
                  Button.w-140( :text="$t('__globeButton.__no')"  type="borderSolid" :disable="false" @buttonClick="vote(false,data.id,index)")
              div(v-else)
                .m-auto.flex.justify-center.mt-16 {{$t('__faqRelated.__thanksForYourFeedback')}}

</template>

<script>


import faqModel from '@/components/faqModel.vue';
import Select from '@/components/Select.vue'
import Button from '@/components/Button.vue';
// import { queryPinList,queryRecentDownload,deletePin,addPin } from "@/api/users.js";
// import { queryDnpRecentList } from "@/api/models.js";
import { faq, voteUp, voteDown } from "@/api/faq.js";


export default {
  name: 'FAQ',
  components: {
    faqModel,
    Button,
    Select,
  },
  data(){
    return {
      faqList:[

      ]
    }
  },
  computed: {
  },
  created(){ 
    

  },
  async mounted(){
    this.$root.loading = true
    await this.getFaq()
    this.$root.loading = false
  },
  methods:{
    
    async getFaq() {//osType
      try{
        const { data } = await faq();
        console.log('AAA',data)
        for (let i = 0; i < data.length; i++) {
          data[i].name = data[i].question;
          data[i].isFeedBack = false;
        }
        this.faqList = data
      } catch(error){
        this.apiError = error.response.status;
      }
    },
    vote(v,id,index){
      // console.log(index)
      this.faqList[index].isFeedBack = true
      v ? this.isVoteUp(id) : this.isVoteDown(id)
    },
    async isVoteUp(e){
      const sendData = {
        id: e
      }
      try{
        const { data } = await voteUp(sendData);
        // console.log(data)
        
      } catch(error){
        this.apiError = error.response.status;
      }
    },
    async isVoteDown(e){
      const sendData = {
        id: e
      }
      try{
        const { data } = await voteDown(sendData);
        // console.log(data)
        
      } catch(error){
        this.apiError = error.response.status;
      }
    },
    back(){
      this.$router.push({path: '/'}).catch(err => err);
    },

    
  },
  watch:{
    
  },
  

}
</script>


<style lang="scss" scoped>

$space-paragraph: 25px;

/deep/ .etor_style { //::v-deep
    line-height: 1.43;
    font-size: 14px;
    *{
        font-size: 12px;
    }
    b{
        font-weight: bold;
    }
    i{
        font-style: italic;
    }
    p{
        &:empty{
            margin-bottom: 0;
            + img{
                margin-top: 0;
            }
        }
        margin-bottom: $space-paragraph;
        + img{
            margin-top: $space-paragraph;
        }
    }
    img{
        max-width: 100%;
        width: auto;
    }
    //disc list
    ul{
        list-style-type: disc;
    }
    //number list
    ol{
        list-style-type: numeric;
    }
    // list 
    ul, ol{
        padding-left: 40px;
        > li{
            img{
                margin-top: $space-paragraph;
            }
            + li{
                margin-top: $space-paragraph;
            }

        }
    }// end: ul, ol

    // link
    a{
        @apply text-main-0;
        text-decoration: underline;
    }

    // ps style
    blockquote{
        position: relative;
        margin: 0;
        padding: 0;
        border: none;
        margin-bottom: $space-paragraph;
        padding-left: 20px;
        font-size: 12px;
        &:before{
            content: ' ';
            position: absolute;
            display: inline-block;
            width: 2px;
            @apply bg-main-0;
            height: 90%;
            left: 0;
            margin: 0 auto;
            top: 50%;
            transform: translateY(-50%);
        }
    }

}

</style>